import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';

export class AppUrlSerializer implements UrlSerializer {
  parse(url: any): UrlTree {
    const dus = new DefaultUrlSerializer();
    return dus.parse(url);
  }

  serialize(tree: UrlTree): any {
    const dus = new DefaultUrlSerializer();
    let path = dus.serialize(tree);
    path = path.replace(/%2C/g, ',');
    path = path.replace(/%3D/g, '=');
    return path;
  }
}
